const AlertWithTimer = () => {
    return (<div></div>);
}

export default AlertWithTimer;